import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

export const unauthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.ensureAuthenticated().pipe(
    tap((isAuthed) => {
      if (isAuthed) {
        console.log('AuthGuard: User is already authenticated, redirecting to dashboard.');
        router.navigate(['/account/dashboard']).catch(() => undefined);
      }
    }),
    map((isAuthed) => !isAuthed)
  );
};
